import { useTranslation } from 'react-i18next'
import { resolveLanguage } from '@/application/i18n/language'
import { localizedAbsoluteUrl } from '@/application/seo/site'

/**
 * Absolute, canonical-host URL of a page IN THE LANGUAGE CURRENTLY DISPLAYED.
 *
 * Pages know their own language-free path (`/about`) — the locale segment is
 * stripped before the router matches — so this is what turns it back into the
 * URL the visitor is actually on (`https://host/en/about`). Using it for
 * `og:url` keeps the shared link, the canonical and the hreflang alternate for
 * that language byte-identical; `absoluteUrl` alone would publish the French
 * URL on all three, and a share of the English page would open in French.
 */
export function useLocalizedUrl(path: string): string {
  const { i18n } = useTranslation()
  return localizedAbsoluteUrl(path, resolveLanguage(i18n.language))
}
